import { backIn } from "./back.js";
const anticipate = (p) => (p *= 2) < 1 ? 0.5 * backIn(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
export {
  anticipate
};
//# sourceMappingURL=anticipate.js.map
